import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Select } from 'antd';
import { useState } from 'react';

import {
  CONSENT_LEGEND_ORDER,
  CONSENT_STATUS_CONFIG,
  ConsentSignalIcon,
} from '../../../components/common/consentSignal/consentSignalStatus';
import { DefaultLayout } from '../../../components/index';
import { useChangePagination } from '../../../hooks';
import { useListStopoversOptimizedQuery } from '../../../services/stopoverApi';
import {
  FilterDefaultLayoutType,
  Stopover as StopoverType,
} from '../../../types';
import { StopoverDetails } from './stopoverDetails/StopoverDetails';
import { StopoverDrawer } from './StopoverDrawer';
import { DefaultLayoutOptimized } from '../../../components/common/DefaultLayoutOptimized/DefaultLayoutOptimized';

const tabs = [
  { label: 'Todas', value: '' },
  { label: 'Esperadas', value: 'WAITING' },
  { label: 'Em andamento', value: 'IN_PROGRESS' },
  { label: 'Finalizadas', value: 'DONE' },
  { label: 'Canceladas', value: 'CANCELED' },
];

const { confirm } = Modal;

// Filtro pelo status documental gravado pela sincronização das anuências do PSP.
const documentStatusOptions = [
  { label: 'Anuências: todas', value: '' },
  { label: 'Anuências: com pendência', value: 'PENDING_ANY' },
  ...CONSENT_LEGEND_ORDER.map((status) => ({
    label: (
      <span>
        <ConsentSignalIcon status={status} showTooltip={false} size={14} />{' '}
        {CONSENT_STATUS_CONFIG[status].label}
      </span>
    ),
    value: status,
  })),
];

export function StopoverOptimized() {
  const { onChangePagination, queryPage } = useChangePagination();
  const [filter, setFilter] = useState<FilterDefaultLayoutType>({
    page_size: 50,
    page: queryPage,
    order_by: 'stopover_is_delayed',
    status: 'WAITING',
  });

  const {
    data: stopoveresData,
    isLoading: isLoadingStopoveresData,
    isFetching: isFetchingStopoveresData,
  } = useListStopoversOptimizedQuery(filter);

  const [filteredStopoveres, setFilteredStopoveres] = useState(
    [] as StopoverType[]
  );

  const [selectedStopover, setSelectedStopover] = useState<StopoverType>(
    {} as StopoverType
  );
  const [hasEdited, setHasEdited] = useState(false);
  const [blockNavigate, setBlockNavigate] = useState(false);

  const [visibleAddStopoverDrawer, setVisibleAddStopoverDrawer] =
    useState(false);

  function closeDrawer() {
    if (hasEdited) {
      confirm({
        title: 'Tem certeza que deseja sair?',
        icon: <ExclamationCircleOutlined />,
        content:
          'Você tem alterações não salvas na escala, ao sair perderá os dados preenchidos.',
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        onOk() {
          close();
        },
      });
    } else {
      close();
    }
  }

  function handleDocumentStatusChange(value: string) {
    onChangePagination(1);
    setFilter((prev) => ({
      ...prev,
      page: 1,
      document_status: (value ||
        undefined) as FilterDefaultLayoutType['document_status'],
    }));
  }

  function close() {
    setVisibleAddStopoverDrawer(false);
    setHasEdited(false);
    setBlockNavigate(false);
  }

  return (
    <>
      <DefaultLayoutOptimized
        title="Escalas"
        tabs={tabs}
        filterField="status"
        defaultActiveKey="WAITING"
        setFilter={setFilter}
        stopoveresData={stopoveresData}
        filteredStopoveres={filteredStopoveres}
        setFilteredStopoveres={setFilteredStopoveres}
        isLoadingStopoveresData={isLoadingStopoveresData}
        isFetchingStopoveresData={isFetchingStopoveresData}
        queryPage={queryPage}
        onChangePagination={onChangePagination}
        selectedStopover={selectedStopover}
        setSelectedStopover={setSelectedStopover}
        visibleAddDataDrawer={visibleAddStopoverDrawer}
        setVisibleAddDataDrawer={setVisibleAddStopoverDrawer}
        labelAddDataDrawer="Nova escala"
        labelPlural="ESCALAS"
        labelSingular="ESCALA"
        pageContext="STOPOVER"
        extraFilters={
          <Select
            defaultValue=""
            options={documentStatusOptions}
            onChange={handleDocumentStatusChange}
            disabled={isLoadingStopoveresData}
            style={{ width: '100%', marginBottom: '16px' }}
          />
        }
      >
        <StopoverDetails
          name="stopover_form"
          setHasEdited={setHasEdited}
          hasEdited={hasEdited}
          blockNavigate={blockNavigate}
          selectedStopover={selectedStopover}
          setSelectedStopover={setSelectedStopover}
          setBlockNavigate={setBlockNavigate}
        />
      </DefaultLayoutOptimized>
      <StopoverDrawer
        visibleDrawer={visibleAddStopoverDrawer}
        closeDrawer={closeDrawer}
        hasEdited={hasEdited}
        setHasEdited={setHasEdited}
        blockNavigate={blockNavigate}
        setBlockNavigate={setBlockNavigate}
        setSelectedStopover={setSelectedStopover}
        close={close}
        setFilteredStopoveres={setFilteredStopoveres}
      />
    </>
  );
}
